/* @jsx h */

const Page = ({ result }) => {
  return (
    <li className="search-result__item">
      <article className="search-result-item">
        <header className="search-result-item__header">
          {result.contentType && (
            <span className="search-result-item__type">
              {result.contentType}
            </span>
          )}
          <h3 className="search-result-item__heading">
            <a className="search-result-item__link" href={result.url}>
              {result.title}
            </a>
          </h3>
        </header>
        <div className="search-result-item__content">
          <div className="text-content">
            {result.teaser && <p>{result.teaser}</p>}
          </div>
        </div>
      </article>
    </li>
  );
};

export default Page;
